<template>
  <div class="data_permissions">
    <div class="across">
      <div class="line"></div>
      <div class="across-title">组织架构</div>
    </div>

    <el-button type="primary" class="addbtn" icon="el-icon-plus" @click="showInput">添加组织</el-button>
    <el-scrollbar class="zhuzhigundong">
      <ul
        class="showMessage"
      >
        <li
          v-for="(item, index) in dynamicTags"
          :key="index"
          @click="li_click(index)"
        >
          <el-input
            class="input-new-tag"
            v-show="item.active"
            v-model="item.name"
            ref="saveTagInput"
            size="small"
            @blur="handleInputConfirm(index)"
            maxlength="30"
          ></el-input>
          <div v-show="!item.active">{{item.name}}</div>
          <i class="el-icon-delete" @click.stop="del_tag(index,item)"></i>
        </li>
      </ul>
    </el-scrollbar>

    <vdialog ref="dialogShow" :title="title" :message="message" @isOk="sure_del"></vdialog>
  </div>
</template>

<script>
  import vdialog from "../components/dialog.vue";

  export default {
    components: {
      vdialog
    },
    data() {
      return {
        delIndex: null, // 要删除下标
        delItem: null, // 要删除的item
        title: "是否删除该组织",
        message: "请确保该组织下无员工账号",
        dynamicTags: [],
        isadd: true,
      };
    },
    methods: {
      // li标签点击事件
      li_click(index) {
        // this.dynamicTags[index].active = true;
        this.dynamicTags = this.dynamicTags.map((_, i) => {
          _.active = false;
          if (i === index) {
            _.active = true;
          }
          return _;
        });
        this.$nextTick(() => {
          console.log(this.dynamicTags);

          this.$refs.saveTagInput[index].focus();
        });
        // 将isadd设为true
        this.isadd = false;
      },
      // 确认删除后返回的函数
      sure_del() {
        console.log(this.delIndex);
        this.$axios
          .post(this.$url.delete, {
            id: this.delItem.id
          })
          .then(res => {
            console.log("我是删除的", res);
            if (res.code === 0) {
              this.dynamicTags.splice(this.delIndex, 1);
              this.$message.success("删除成功");
            }
          });
      },
      // 删除图标点击事件
      del_tag(index, item) {
        this.$refs.dialogShow.centerDialogVisible = true;
        this.delIndex = index;
        this.delItem = item;
      },
      // 输入框显示 新增类目
      showInput() {
        this.dynamicTags.unshift({
          name: "",
          active: true
        });
        this.$nextTick(() => {
          this.$refs.saveTagInput[0].focus();
        });
        // 将isadd设为true
        this.isadd = true;
      },
      // 输入框失去焦点
      handleInputConfirm(index) {
        this.dynamicTags[index].active = false;
        let name = this.dynamicTags[index].name.trim();
        if (name) {
          if (name.length > 30) {
            this.$message.error("最多30个字符");
            this.getList()
            return
          }
          let delIndex = this.dynamicTags.findIndex((_, i) => {
            return _.name === name && index !== i;
          });
          if (delIndex !== -1) {
            if (this.isadd) {
              this.dynamicTags.splice(index, 1);
            } else {
              this.$message.error("该组织已存在");
            }
            this.getList()
          } else {
            let id = this.dynamicTags[index].id || '';
            // 判断是新增组织还是编辑组织
            if (!id) {
              //新增接口
              this.$axios
                .post(this.$url.add, {
                  name: name
                })
                .then(res => {
                  if (res.code === 0) {
                    this.$message.success("新增成功");
                    // 重新获取列表
                    this.getList()
                  }
                });
            } else {
              // 编辑接口
              this.$axios
                .post(this.$url.update, {
                  name: name,
                  id: id
                })
                .then(res => {
                  console.log("我是编辑", res);
                  if (res.code === 0) {
                    this.$message.success("编辑成功");
                  } else {
                    this.getList()
                  }
                });
            }
          }
        } else {
          this.$message.error("组织名称不能为空");
          this.getList()
        }
      },

      // 获取组织列表
      getList() {
        this.$axios.post(this.$url.list, {}).then(res => {
          console.log("企业列表", res);
          if (res.code == 0) {
            this.dynamicTags = res.data;
            this.dynamicTags = this.dynamicTags.map(_ => {
              _["active"] = false;
              return _;
            });
          }
        });
      },

    },
    created() {
      // 组织列表
      this.getList();
    }
  };
</script>

<style lang="less" scoped>
  .zhuzhigundong {
    height: 700px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 550px
  }

  .data_permissions {
    padding: 30px;
    background-color: #fff;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .active {
    color: #0094ff;
  }

  .showMessage {
    li {
      list-style: disc;
    }
  }

  .del_title {
    font-size: 18px;
    font-weight: bold;
    color: rgba(72, 72, 72, 1);
    line-height: 28px;
    margin-bottom: 10px;
  }

  ::v-deep .el-dialog__header {
    padding: 0px;
  }

  ::v-deep .el-dialog__body {
    padding-top: 55px !important;
    padding-bottom: 10px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .el-icon-delete {
    font-size: 14px;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 7px;
  }

  .input-new-tag {
    ::v-deep .el-input__inner {
      width: 458px !important;
      height: 21px !important;
      border: none;
      padding-left: 0;
    }
  }

  ul {
    margin-left: 15px;
  }


  li {
    margin-bottom: 10px;
    position: relative;
    width: 480px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(68, 68, 68, 1);
    line-height: 22px;
  }

  .across {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .line {
      width: 3px;
      height: 19px;
      background: rgba(102, 102, 102, 1);
      margin-right: 5px;
    }

    .across-title {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }

  .addbtn {
    margin-bottom: 20px;
    background: rgba(89, 204, 225, 1) !important;
    border: 0;
  }

  .showMessage {
    cursor: pointer;

    li:hover {
      color: #59cce1;
    }
  }
</style>
